/**
 * AIWA Reveal — Cartier-style scroll reveal
 * Gracefully fades up homepage sections as they enter the viewport.
 * Works two ways:
 *   1. Auto: targets all .shopify-section elements below the fold, decided by
 *      actual viewport geometry at load time (not a fixed section count)
 *   2. Manual: any element with [data-reveal] attribute (for granular use)
 * No dependencies. ~1KB gzipped.
 */
(function () {
  'use strict';

  var ACTIVE_CLASS = 'aiwa-revealed';

  function markReady(el) {
    el.classList.add(ACTIVE_CLASS);
  }

  // Bail gracefully for old browsers
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.shopify-section, [data-reveal]').forEach(markReady);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.dataset.revealDelay || 0;
        setTimeout(function () { markReady(el); }, Number(delay));
        io.unobserve(el);
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -32px 0px' }
  );

  function init() {
    // Auto-tag sections below the fold. Whatever is already visible in the
    // viewport at load time (announcement bar, header, hero, or — on
    // hero-less templates like search/collection — the first content grid)
    // is shown immediately with no animation; only sections the visitor has
    // to scroll to reach get the fade-up treatment. A fixed skip-count of
    // "first N sections" was tried before this and undercounted on any page
    // whose first content section wasn't exactly 2 sections deep (e.g. search
    // results, where the product grid IS the 3rd section), so it still
    // opacity-faded content that was already on screen at load.
    var vh = window.innerHeight;
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        markReady(el);
        return;
      }
      el.classList.add('aiwa-will-reveal');
      io.observe(el);
    });

    // Manual [data-reveal] anywhere on the page
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after Shopify section hot-reloads in theme editor
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.aiwa-will-reveal:not(.' + ACTIVE_CLASS + ')').forEach(function (el) {
      io.observe(el);
    });
  });
})();
